<app-search-field
  [ngModel]="filter.value"
  [debounceModelDelayMs]="debounceModelChangeTimeMs"
  [debounceFilterFn]="debounceFilterFn"
  (debounceModelChange)="setNewFilter($event)" />

@if (showCheckboxForEmptyValue) {
  <mat-checkbox
    [color]="'primary'"
    [(ngModel)]="filter.is_null"
    (change)="updateFilterChangeTime()"
    [labelPosition]="'after'">
    Empty
  </mat-checkbox>
}
